/**
 * 消息气泡（story AC-8/AC-9）。我方右对齐(.bubble.self)/对方左对齐(.bubble)。
 * 状态标：sending / sent / 对方离线 / 040206 不可重试 / 其它失败可重试。
 * 风险提示条置于气泡上方（命中且未关闭）。
 */
import type { ChatBubble } from '@/im/chatMessages';
import { isRetryable } from '@/im/chatMessages';
import { formatRelativeTime } from '@/lib/timeFormat';
import { RiskBanner } from './RiskBanner';

interface ChatBubbleViewProps {
  bubble: ChatBubble;
  isMine: boolean;
  bannerDismissed: boolean;
  onDismissBanner: (clientMsgId: string) => void;
  onRetry: (bubble: ChatBubble) => void;
}

export function ChatBubbleView({
  bubble,
  isMine,
  bannerDismissed,
  onDismissBanner,
  onRetry,
}: ChatBubbleViewProps) {
  const showBanner = !!bubble.riskKeywords && bubble.riskKeywords.length > 0 && !bannerDismissed;
  const timeText = formatRelativeTime(bubble.sentAtMs);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: isMine ? 'flex-end' : 'flex-start',
      }}
    >
      {showBanner && <RiskBanner onClose={() => onDismissBanner(bubble.clientMsgId)} />}

      <div className={isMine ? 'bubble self' : 'bubble'}>{bubble.content}</div>

      <div className="xs muted" style={{ marginTop: 'var(--space-1)' }}>
        {bubble.status === 'sending' && <span data-testid="bubble-sending">发送中…</span>}
        {bubble.status === 'sent' && bubble.recipientOffline && <span>对方离线</span>}
        {bubble.status === 'sent' && !bubble.recipientOffline && timeText.length > 0 && (
          <span>{timeText}</span>
        )}
        {bubble.status === 'failed' && bubble.errorCode === '040206' && (
          <span data-testid="bubble-audit-reject" style={{ color: 'var(--color-destructive)' }}>
            消息含违规内容,无法发送
          </span>
        )}
        {bubble.status === 'failed' && isRetryable(bubble) && (
          <button
            type="button"
            data-testid="bubble-retry"
            onClick={() => onRetry(bubble)}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              color: 'var(--color-destructive)',
              padding: 0,
            }}
          >
            发送失败,点击重试
          </button>
        )}
      </div>
    </div>
  );
}
